import { Outlet, useParams } from 'react-router';
import { usePortfolioCompany } from '@/hooks/react-query/usePortfolio';
import { PageSkeleton } from '@/components/ui/DataLoader';

export function PortfolioPageLayout() {
  const { companyId } = useParams<{ companyId: string }>();
  const { data: company, isLoading } = usePortfolioCompany(companyId ?? '');

  if (isLoading) {
    return <PageSkeleton showCards />;
  }

  if (!company) {
    return (
      <div className="min-h-full p-6">
        <p className="text-muted-foreground">Portfolio company not found</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <Outlet context={{ company, companyId: companyId! }} />
    </div>
  );
}
